import React, { useEffect, useCallback, useState } from 'react';
import Alert from '../Modal/Alert';
import { AUTH_CONFIG } from '../../pages/Authentication/auth.config';
import { useDispatch } from 'react-redux';
import { persistor } from '../../redux/store';
import { setJwtExpired } from '../../redux/slices/auth/authSlice';
import { useLoginUser } from '../../hooks/useLoginUser';
import { setLogoutHandler } from '../../utils/logoutHandler';
import { logoutUser } from '../../redux/slices/auth/authApi';
import { trackEvent } from '../../utils/mixpanelService';

const AutoLogoutAlert = () => {
  const dispatch = useDispatch();
  const { jwtExpired } = useLoginUser();
const handleRefresh = () => {
    window.location.reload(true);
  };
  const [logoutReason, setLogoutReason] = useState('session_expired');
  const performLogout = useCallback(async () => {
    await logoutUser();
    await trackEvent({eventName:"User Logout"})
    // trackEvent("logoutSucessfull")
    dispatch({ type: 'RESET_STORE' });
    dispatch(setJwtExpired(false));
    localStorage.removeItem("logoutReason");
    persistor.purge();
    handleRefresh();
  }, [dispatch]);

  // Register global logout trigger once
  useEffect(() => {
    setLogoutHandler(() => {
      const reason = localStorage.getItem("logoutReason") || "session_expired";
      setLogoutReason(reason);
      dispatch(setJwtExpired(true));
    });
  }, [dispatch]);

  // Auto-logout after delay when jwtExpired flips true
  useEffect(() => {
    if (!jwtExpired) return;

    const timer = setTimeout(() => {
      performLogout();
    }, 2000);

    return () => clearTimeout(timer);
  }, [jwtExpired, performLogout]);

  const handleClose = () => {
    if (!jwtExpired) return;
    performLogout();
  };
  const isMultipleSession = logoutReason === "multiple_session";
  const isIpSession = logoutReason === "ip_session";

  let title = AUTH_CONFIG.MESSAGES.TITLE;
  let description = "You will need to relogin in next 2 seconds";

  if (isMultipleSession) {
    title = "Session Ended";
    description = "Your account was logged in from another device.";
  }

  if (isIpSession) {
    title = "Session Expired";
    description = "Your IP address changed. Please login again.";
  }

  return (
    <Alert
      isOpen={jwtExpired}
      onClose={handleClose}
      // title={AUTH_CONFIG.MESSAGES.TITLE}
      title={title}
      // description="You will need to relogin in next 2 seconds"
      description={description}
      cancelButton={{
        ...AUTH_CONFIG.BUTTONS.CANCEL,
        onClick: handleClose,
        show: false,
      }}
      acceptButton={{
        ...AUTH_CONFIG.BUTTONS.ACCEPT,
        onClick: handleClose,
        show: false,
      }}
      closeOnOutsideClick={false}
      zIndex={60}
    />
  );
};

export default AutoLogoutAlert;